/*-- Collection Page Quickview Events --*/
window.bindCollectionEvents = function() {
  /**
     Modal open click event
    ** @params event with target
    **/
  const _modalOpener = (event) => {
    console.log(event.currentTarget);
    document.querySelector(`#custom-model_${event.currentTarget.getAttribute("data-handle")}`).classList.add("model-open")
  };

  /**
      Modal close click event

    ** @params event with target
    **/
  const _modalCloser = (event) => document.querySelector(`#custom-model_${event.currentTarget.getAttribute("data-handle")}`).classList.remove("model-open");

  document.querySelectorAll(".select_options:not(.evt-binded)").forEach((quickViewBtn) => {
    quickViewBtn.classList.add("evt-binded");
    quickViewBtn.addEventListener("click", _modalOpener.bind(this), true);
  });

  document.querySelectorAll(".close-btn:not(.evt-binded)").forEach((closeBtn) => {
    closeBtn.classList.add("evt-binded");
    closeBtn.addEventListener("click", _modalCloser.bind(this), true);
  });
  
  document.querySelectorAll(".bg-overlay:not(.evt-binded)").forEach((overlay) => {
    overlay.classList.add("evt-binded");
    overlay.addEventListener("click", _modalCloser.bind(this), true);
  });
}

/*-- Collection Page Quickview Events --*/
window.onload = function() {
  /*- Bind Collection Events on Window Load -*/
  window.bindCollectionEvents();
}

// if(document.getElementById("detail_me")){
// document.getElementById("detail_me").open = true;
// }

const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');
  
  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }
  
  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}

items.forEach(item => item.addEventListener('click', toggleAccordion));

const pop_up_close = document.querySelector("#pop_up_close_1");

  pop_up_close?.addEventListener('click', () => {
   $('.cart_alert_message').hide();
});

const order_address_click = document.querySelectorAll(".order_address_click");
const order_address_show = document.querySelectorAll(".order_address_show");
const order_shipping_address_click = document.querySelectorAll(".order_shipping_address_click");
const order_shipping_address = document.querySelectorAll(".order_shipping_address");

order_address_click.forEach(function(order_address_clicks){
  order_address_clicks.addEventListener('click', (e) => {
//     console.log(e.target.nextSibling(".order_address_show").classList.toggle("hide"));
    console.log(e.target);
    e.target.nextElementSibling.classList.toggle("hide");
  });
});

order_shipping_address_click.forEach(function(order_shipping_address_clicks){
  order_shipping_address_clicks.addEventListener('click', (e) => {
    console.log(e.target);
    e.target.nextElementSibling.classList.toggle("hide");
});
});

window.setGridHeight_blog_title = (selector) => {
    this.heightArray = [];
    this.offsetArrayArray = [];
    this.sectionArray = [];
    document.querySelectorAll(selector).forEach((grid, i) => {
        var tmp = { 'index': i, 'offsetheight': grid.closest(".blog-articles").offsetTop };
    //  console.log(tmp);
        this.offsetArrayArray.push(tmp)
    });
    this.diffrentsHeights = []
    this.offsetArrayArray.forEach(function(e) {
        if (this.diffrentsHeights.includes(e.offsetheight) == false) {
            this.diffrentsHeights.push(e.offsetheight)
        }
    });
    this.diffrentsHeights.forEach(function(e) {
        var data = [];
        for (var i = 0; i < this.offsetArrayArray.length; i++) {
            if (this.offsetArrayArray[i].offsetheight == e) {
                data.push(this.offsetArrayArray[i]);
            }
        }
        var getAllHeightArray = [];
        data.forEach(function(ele) {
            document.querySelectorAll(selector)[ele.index].removeAttribute('style');
            getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
        })
        var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
        data.forEach(function(ele) {
            document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
        });
    });
}
window.setGridHeight_blog_title('h3.card__heading.h3');

window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`[data-equal]`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}


$('.slider-pro').on('init', function(event, slick){
   window.setGridHeight('h4.p.custom_collection_title');
    window.onresize = (function() {
     window.setGridHeight('h4.p.custom_collection_title');
    });
});

window.setGridHeight_coll_grid = (selector) => {
    this.heightArray = [];
    this.offsetArrayArray = [];
    this.sectionArray = [];
    document.querySelectorAll(selector).forEach((grid, i) => {
        var tmp = { 'index': i, 'offsetheight': grid.closest("#main-collection-product-grid").offsetTop };
    //  console.log(tmp);
        this.offsetArrayArray.push(tmp)
    });
    this.diffrentsHeights = []
    this.offsetArrayArray.forEach(function(e) {
        if (this.diffrentsHeights.includes(e.offsetheight) == false) {
            this.diffrentsHeights.push(e.offsetheight)
        }
    });
    this.diffrentsHeights.forEach(function(e) {
        var data = [];
        for (var i = 0; i < this.offsetArrayArray.length; i++) {
            if (this.offsetArrayArray[i].offsetheight == e) {
                data.push(this.offsetArrayArray[i]);
            }
        }
        var getAllHeightArray = [];
        data.forEach(function(ele) {
            document.querySelectorAll(selector)[ele.index].removeAttribute('style');
            getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
        })
        var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
        data.forEach(function(ele) {
            document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
        });
    });
}
    window.setGridHeight_coll_grid('h3.card__heading.h6');


 $(".header__primary").hover(function () {
    $(this).toggleClass("dropdown_open");
   $('details').removeAttr('open');
   $(this).find('details').attr('open', '');
 });
$( ".header__primary" ).mouseleave(function() {
  $('details').removeAttr('open');
});

document.getElementById("Search-In-Template").addEventListener("input", function() {
  document.getElementById("search-button").disabled = !this.value;
});

$(document).ready(function() {
    // Set a timeout to delay the execution of the function inside
    setTimeout(function() {
        $('.thumbnail-list__item:not(.hideVariant) button').first().trigger('click');
    }, 1000); // Adjust the timeout duration in milliseconds as needed

  $('.product_options_value .swatch').click(function(){
     setTimeout(function() {
        $('.thumbnail-list__item:not(.hideVariant) button').first().trigger('click');
    }, 500); // Adjust the timeout duration in milliseconds as needed
  })
});


  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.mobile-facets__close');

    if (!closeBtn) return;

    const disclosure = document.querySelector('.mobile-facets__disclosure');

    if (disclosure) {
      disclosure.removeAttribute('open');
    }
  });